var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3332H10.3337C8.46682 13.3332 7.5327 13.3332 6.81966 13.6965C6.19245 14.0161 5.68289 14.5256 5.36331 15.1528C5 15.8659 5 16.8 5 18.6668V28.0002C5 29.867 5 30.7999 5.36331 31.513C5.68289 32.1402 6.19245 32.6506 6.81966 32.9702C7.532 33.3332 8.46499 33.3332 10.3282 33.3332H29.6718C31.535 33.3332 32.4667 33.3332 33.179 32.9702C33.8062 32.6506 34.3175 32.1402 34.637 31.513C35 30.8006 35 29.869 35 28.0058V18.6614C35 16.7982 35 15.8652 34.637 15.1528C34.3175 14.5256 33.8062 14.0161 33.179 13.6965C32.466 13.3332 31.5338 13.3332 29.667 13.3332H26.6667M13.3333 13.3332H26.6667M13.3333 13.3332C13.3333 9.65127 16.3181 6.6665 20 6.6665C23.6819 6.6665 26.6667 9.65127 26.6667 13.3332",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon5);
export default __webpack_public_path__ + "static/media/discoverItemIcon5.725fcf7b38700c5e73e92e70c01beb55.svg";
export { ForwardRef as ReactComponent };